module.exports = __webpack_public_path__ + "static/media/CityIcon.b7b683c9.svg";